import { Component, NgModule, Output, Input, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';
import { DxTooltipModule, DxTooltipComponent } from 'devextreme-angular';
import * as events from 'devextreme/events';
import { Subscription } from 'rxjs';
import { SharedComponentService } from '../common/service/sharedcomponent.service';
import { SharedService } from "../services/SharedService";

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: true })
  menu: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  refreshEventSubscription: Subscription;
  private _selectedItem: String = "";
  tooltipContent: string = "";
  target: any;
  isVisible: boolean = false;
  noRole: boolean;

  @Input()
  set selectedItem(value: String) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }

    this.menu.instance.selectItem(value);
  }

  private _items;
  items: any[] = [];

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;

    if (!this.menu.instance) {
      return;
    }

    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  constructor(private elementRef: ElementRef, private sharedComponentService: SharedComponentService,
    public SharedSvc: SharedService) {
    this.SharedSvc.noRoleObs.subscribe(noRole => this.noRole = noRole);
    this.refreshEventSubscription = this.sharedComponentService.getEvent().subscribe(() => {
      this.unselectAllItems();
    });
    this._items = [{
      order: 0,
      text: 'Maintenance Screens',
      icon: 'preferences',
      items: [{
        text: 'Home',
        path: '/home'
      }, {
        text: 'Roles',
        path: '/userroles'
      }, {
        text: 'Plant/Site List',
        path: '/plants'
      }, {
        text: 'Contracts',
        path: '/contracts'
      }, {
        text: 'Equipment and Technology',
        path: '/equipments'
      }, {
        text: 'Activity Process/Feedstock',
        path: '/activityprocessfeedstock'
      }, {
        text: 'Map Industry Codes',
        path: '/industrycodes'
      }, {
        text: 'Pipeline',
        path: '/pipelines'
      }, {
        text: 'MI/MVA Upload',
        path: '/mvaupload'
      }
      ]
    }, {
      order: 4,
      text: 'Reports',
      icon: 'fa fa-clipboard',
      items: [{
        text: "H2",
        items: [{
          text: 'Forecast: By Region/Country',
          path: '/h2forecastbyregion'

        }, {
          text: 'SMR/ASU Awards by Country',
          path: '/smrandasuawardsreport'
        }, {
          text: 'Forecast/SMR Awards',
          path: '/h2forecaststeamreformerawards'

        }, {
          text: 'SMR Awards: By Region/Country',
          path: '/h2globalsteamreformerawards'

        }, {
          text: 'HYCO Awards: Global',
          path: '/h2globalhycoawardsawards'

        }, {
          text: 'HYCO Awards SOG Competitor',
          path: '/h2globalhycoawardsawardssogcompetitor'

        }]
      }, {
        text: "O2",
        items: [{
          text: 'Global O2 Forecast',
          path: '/globalasuforecastreport'
        }, {
          text: 'ASU Reference List',
          path: '/o2portalasureferencelist'

        }, {
          text: 'Awards By Region',
          path: '/o2portalawardsbyregion'
        }, {
          text: 'Awards By Process',
          path: '/o2portalawardsbyprocess'
        }, {
          text: 'Global ASU Awards',
          path: '/o2portalglobalasuawards'
        }, {
          text: 'Awards by Nominal Capacity',
          path: '/o2portalasuawardsbynominalcapacity'
        }, {
          text: 'Awards by Application',
          path: '/o2portalasuawardsbyapplication'
        }, {
          text: 'Awards by Competitor',
          path: '/o2portalasuawardsbycompetitor'
        }, {
          text: 'ASU/HyCO Awards SOG',
          path: '/o2portalasuhycoawardssog'
        }, {
          text: 'ASU/SMR Investment',
          path: '/o2asusmr'
        }]
      }, {
        text: "CO2",
        items: [{
          text: 'CO2 Better Served',
          path: '/co2betterserved'
        }, {
          text: 'CO2 Map By SAP Plant',
          path: '/co2mapbysapplant'
        }]
      },
      {
        text: "Plants",
        items: [{
          text: 'All Plants',
          path: '/allplants'
        },
        {
          text: 'Distance To Plant',
          path: '/distncetoplant'
        }]
      }, {
        text: 'Territory Post Code',
        path: '/territorypostcode'
      },
      {
        text: "Location Snapshot",
        path: '/locationsnapshot'
      }, {
        text: "CRM Data by Zip/Territory",
        path: '/crmdatabyzipterritory'
      }, {
        text: "Refinery Balance",
        path: '/refinerybalance'
      }, {
        text: "TGEE Prospects Chemicals & Other",
        path: '/tgeeProspectsChemicalsOther'
      }, {
        text: "TGEE ASU Map by Manufacturer",
        path: '/tgeeManufacturerData'
      }]
    }];

    this.items = this._items;
  }


  onContentReady(e: any) {
    let elements = e.component.element().querySelectorAll(".dx-treeview-item");
    let that = this;
    elements.forEach((el: any, index: any) => {
      el.addEventListener("mousemove", (event: any) => {
        that.tooltipContent = event.target.innerText;
        //that.tooltip.instance.option("target", event.target);
        //that.tooltip.instance.show();
      });
      el.addEventListener("mouseout", (event: any) => {
        //this.tooltip.instance.hide();
      });
    });
  }

  onItemClick(event: any) {
    this.selectedItemChanged.emit(event);
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e: any) => {
      this.openMenu.next(e);
    });
  }

  unselectAllItems() {
    this.menu.instance.unselectAll();
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }
}
